import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { GetEducationListQueryParamsType } from './getEducationListQuery.type';
import { getEducationListFunction } from './getEducationListQueryFunction';
import { getNextPage } from '@/modules/FileList/utils/getNextPage';

export const getEducationListInfiniteQueryOptions = (
  params: GetEducationListQueryParamsType = {},
) => {
  return infiniteQueryOptions({
    queryKey: ['education-list', params],
    queryFn: ({ pageParam }) =>
      getEducationListFunction({
        ...params,
        page: pageParam as number,
      }),
    initialPageParam: 1,
    getNextPageParam: getNextPage,
    enabled: true,
  });
};

export const getEducationListQueryOptions = (
  params: GetEducationListQueryParamsType = {},
) => {
  return queryOptions({
    queryKey: ['education-list', params],
    queryFn: () => getEducationListFunction(params),
    enabled: true,
  });
};
